import { PermissionGroupName } from 'Services/Api/Roles/Types';

const PERMISSION_CODE_LABEL: Record<string, string> = {
	generate_dashboard_executive_summary: "role.editRole.permissions.generate_dashboard_executive_summary",
	view_dashboard_elearning: "role.editRole.permissions.view_dashboard_elearning",
	view_dashboard_saq_compliance: "role.editRole.permissions.view_dashboard_saq_compliance",
	view_dashboard_scanning: "role.editRole.permissions.view_dashboard_scanning",
	view_dashboard_my_results: "role.editRole.permissions.view_dashboard_my_results",
	view_dashboard_overview: "role.editRole.permissions.view_dashboard_overview",
	view_dashboard_phishing: "role.editRole.permissions.view_dashboard_phishing",
	view_dashboard_spotcheck: "role.editRole.permissions.view_dashboard_spotcheck",
	view_user_activity: "role.editRole.permissions.view_user_activity",
	create_force_sync: "role.editRole.permissions.create_force_sync",
	add_group: "role.editRole.permissions.add_group",
	add_tenant: "role.editRole.permissions.add_tenant",
	change_group_password: "role.editRole.permissions.change_group_password",
	delete_group: "role.editRole.permissions.delete_group",
	delete_tenant: "role.editRole.permissions.delete_tenant",
	edit_group: "role.editRole.permissions.edit_group",
	edit_tenant: "role.editRole.permissions.edit_tenant",
	export_groups: "role.editRole.permissions.export_groups",
	group_manager_view_page: "role.editRole.permissions.group_manager_view_page",
	move_group: "role.editRole.permissions.move_group",
	restore_group: "role.editRole.permissions.restore_group",
	restore_tenant: "role.editRole.permissions.restore_tenant",
	edit_mapping_wizard: "role.editRole.permissions.edit_mapping_wizard",
	view_mapping_wizard: "role.editRole.permissions.view_mapping_wizard",
	add_ownership_group: "role.editRole.permissions.add_ownership_group",
	delete_ownership_group: "role.editRole.permissions.delete_ownership_group",
	edit_ownership_group: "role.editRole.permissions.edit_ownership_group",
	export_ownership_group: "role.editRole.permissions.export_ownership_group",
	view_ownership_groups: "role.editRole.permissions.view_ownership_groups",
	create_report_current_historical: "role.editRole.permissions.create_report_current_historical",
	view_standard_reports: "role.editRole.permissions.view_standard_reports",
	get_system_by_id: "role.editRole.permissions.get_system_by_id",
	get_systems: "role.editRole.permissions.get_systems",
	add_system_role: "role.editRole.permissions.add_system_role",
	clone_system_role: "role.editRole.permissions.clone_system_role",
	delete_system_role: "role.editRole.permissions.delete_system_role",
	edit_system_role: "role.editRole.permissions.edit_system_role",
	export_system_roles: "role.editRole.permissions.export_system_roles",
	system_role_manager_view_page: "role.editRole.permissions.system_role_manager_view_page",
	view_training_assignment_wizard: "role.editRole.permissions.view_training_assignment_wizard",
	activate_disable_user__admin: "role.editRole.permissions.activate_disable_user__admin",
	activate_disable_user__manager: "role.editRole.permissions.activate_disable_user__manager",
	activate_disable_user__owner: "role.editRole.permissions.activate_disable_user__owner",
	activate_disable_user__superadmin: "role.editRole.permissions.activate_disable_user__superadmin",
	activate_disable_user__user: "role.editRole.permissions.activate_disable_user__user",
	add_user__admin: "role.editRole.permissions.add_user__admin",
	add_user__manager: "role.editRole.permissions.add_user__manager",
	add_user_notification: "role.editRole.permissions.add_user_notification",
	add_user__owner: "role.editRole.permissions.add_user__owner",
	add_user__superadmin: "role.editRole.permissions.add_user__superadmin",
	add_user__user: "role.editRole.permissions.add_user__user",
	assign__Cybersecurity: "role.editRole.permissions.assign__Cybersecurity",
	"assign__Secondary role": "role.editRole.permissions.assign__Secondary role",
	view_phishing_manager: "role.editRole.permissions.view_phishing_manager",
	delete_user__admin: "role.editRole.permissions.delete_user__admin",
	delete_user__manager: "role.editRole.permissions.delete_user__manager",
	delete_user__owner: "role.editRole.permissions.delete_user__owner",
	delete_user__superadmin: "role.editRole.permissions.delete_user__superadmin",
	delete_user__user: "role.editRole.permissions.delete_user__user",
	edit_user__admin: "role.editRole.permissions.edit_user__admin",
	edit_user__manager: "role.editRole.permissions.edit_user__manager",
	edit_user__owner: "role.editRole.permissions.edit_user__owner",
	edit_user__superadmin: "role.editRole.permissions.edit_user__superadmin",
	edit_user__user: "role.editRole.permissions.edit_user__user",
	export_user_audit_log: "role.editRole.permissions.export_user_audit_log",
	export_users: "role.editRole.permissions.export_users",
	move_user__admins: "role.editRole.permissions.move_user__admins",
	move_user__users: "role.editRole.permissions.move_user__users",
	reset_2fa__admin: "role.editRole.permissions.reset_2fa__admin",
	reset_2fa__manager: "role.editRole.permissions.reset_2fa__manager",
	reset_2fa__owner: "role.editRole.permissions.reset_2fa__owner",
	reset_2fa__superadmin: "role.editRole.permissions.reset_2fa__superadmin",
	reset_2fa__user: "role.editRole.permissions.reset_2fa__user",
	reset_password__admin: "role.editRole.permissions.reset_password__admin",
	reset_password__manager: "role.editRole.permissions.reset_password__manager",
	reset_password__owner: "role.editRole.permissions.reset_password__owner",
	reset_password__superadmin: "role.editRole.permissions.reset_password__superadmin",
	reset_password__user: "role.editRole.permissions.reset_password__user",
	restore_user__admin: "role.editRole.permissions.restore_user__admin",
	restore_user__manager: "role.editRole.permissions.restore_user__manager",
	restore_user__owner: "role.editRole.permissions.restore_user__owner",
	restore_user__superadmin: "role.editRole.permissions.restore_user__superadmin",
	restore_user__users: "role.editRole.permissions.restore_user__users",
	user_manager_screen_view: "role.editRole.permissions.user_manager_screen_view",
	view_user__admin: "role.editRole.permissions.view_user__admin",
	view_user_audit_log: "role.editRole.permissions.view_user_audit_log",
	view_user__manager: "role.editRole.permissions.view_user__manager",
	view_user__owner: "role.editRole.permissions.view_user__owner",
	view_user__superadmin: "role.editRole.permissions.view_user__superadmin",
	view_user__user: "role.editRole.permissions.view_user__user",
	export_ownership_groups: "role.editRole.permissions.export_ownership_groups",
	move_user__admin: "role.editRole.permissions.move_user__admin",
	move_user__manager: "role.editRole.permissions.move_user__manager",
	move_user__user: "role.editRole.permissions.move_user__user",
	restore_user__user: "role.editRole.permissions.restore_user__user"
}

export function getPermissionLabel(code: string): string {
	return PERMISSION_CODE_LABEL[code] ?? code;
}

export const PERMISSION_GROUP_HEADING_BY_NAME = {
	[PermissionGroupName.GroupsManagement]:
		'role.editRole.editRolePermissionGroups.groupsManagement',
	[PermissionGroupName.OwnershipGroupsManagement]:
		'role.editRole.editRolePermissionGroups.ownershipGroupsManagement',
	[PermissionGroupName.SystemRolesManagement]:
		'role.editRole.editRolePermissionGroups.systemRolesManagement',
	[PermissionGroupName.UsersManagement]:
		'role.editRole.editRolePermissionGroups.usersManagement',
	[PermissionGroupName.DashboardManagement]:
		'role.editRole.editRolePermissionGroups.dashboardManagement',
	[PermissionGroupName.ReportsManagement]:
		'role.editRole.editRolePermissionGroups.reportsManagement',
	[PermissionGroupName.ForceSyncManagement]:
		'role.editRole.editRolePermissionGroups.forceSyncManagement',
	[PermissionGroupName.SystemsManagement]:
		'role.editRole.editRolePermissionGroups.systemsManagement',
	[PermissionGroupName.MappingManagement]:
		'role.editRole.editRolePermissionGroups.mappingManagement',
	[PermissionGroupName.PhishingManagerManagement]:
		'role.editRole.editRolePermissionGroups.phishingManagerManagement',
	[PermissionGroupName.TrainingManagement]:
		'role.editRole.editRolePermissionGroups.trainingManagement'
};
